import axiosInstance from "./AxiosInstance";

export const getJiraissueDetailsApi = (id, params) =>
  axiosInstance.get(`jira/activity/${id}`, {
    params: {
      activity_type: params?.activity_type
    }
  });
